import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { View } from "../../../../components/layout/View";
import { PageType } from "../../../../config/page.types";
import { useBreadcrumbs } from "../../../../context/BreadcrumbsProvider";
import SupersetDashboard from "./components/SupersetDashboard";

const DataInsightsDashboardDetail = () => {
	const { visitPage } = useBreadcrumbs();

	const params = useParams();
	const dashboardId = params.id as string;

	useEffect(() => {
		if (dashboardId) {
			visitPage(PageType.DataInsightsDashboardDetail, false, dashboardId);
		}
	}, [dashboardId, visitPage]);

	return (
		<View
			pageType={PageType.DataInsightsDashboardDetail}
			height="100dvh"
			sx={{
				display: "flex",
				flexDirection: "column",
				minWidth: 0,
				overflow: "hidden",
				"& > .MuiStack-root": {
					flexShrink: 0,
				},
			}}
		>
			<SupersetDashboard dashboardId={dashboardId} />
		</View>
	);
};

export default DataInsightsDashboardDetail;
